import { gqlTagGira } from '@atlassian/jira-apollo-gira';

export const NUMBER_FRAGMENT = gqlTagGira`
    fragment jiraNumberFieldFragment on JiraNumberField {
        number
        fieldConfig {
          isEditable
        }
    }
`;
